import React, { useState, useContext, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import ReactTooltip from "react-tooltip";

import avatar from "Assets/avatarnew.svg";
import { org_friendly_url } from "Api/Api";
import UserContext from "store/UserContext";
import presentImg from "Assets/present-img.svg";
import playBtn from "Assets/play-btn.png";
import { local_routes } from "utils/Routes";
import { assembleNickname, getRelativeTime } from "utils/Helper";
import "./style.css";

const convert = (n) => {
  if (n < 1e3) return n;
  if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(1) + "K";
  if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + "M";
  if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + "B";
  if (n >= 1e12) return +(n / 1e12).toFixed(1) + "T";
};

const PresentationCard = (props) => {
  const userContext = useContext(UserContext);
  const [adjusted_image_url, set_adjusted_image_url] = useState("");
  const [presentation_link, set_presentation_link] = useState("");
  const [presenter_info, set_presenter_info] = useState({});
  const [view_count_converted, set_view_count_converted] = useState("0");

  useEffect(() => {
    let workspace_base_url = "";
    if (org_friendly_url) {
      workspace_base_url = local_routes.workspace + "/" + org_friendly_url;
    }

    if (props.presentation_info.view_count) {
      set_view_count_converted(convert(props.presentation_info.view_count));
    }

    if (props.presentation_info.friendly_url) {
      set_presentation_link(
        workspace_base_url +
          local_routes.presentations +
          "/" +
          props.presentation_info.friendly_url
      );
    }

    if (props.presentation_info.image_url) {
      let array = props.presentation_info.image_url.split("/");
      let pad_color = 'black';
      if (props.presentation_info.pad_color) {
        pad_color = props.presentation_info.pad_color;
      }
      set_adjusted_image_url(
        `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/640x360/${array[5]}`
      );
    }

    if (
      props.presentation_info.users &&
      props.presentation_info.users.length > 0
    ) {
      // see if we have a defined presenter
      let presenters_array = props.presentation_info.users.filter((item) => {
        if (item.xref_data && item.xref_data.presenter_integer) {
          return true;
        } else {
          return false;
        }
      });
      presenters_array = presenters_array.sort((a, b) =>
        a.xref_data.presenter_integer > b.xref_data.presenter_integer ? 1 : -1
      );
      let temp_presenter_info;
      if (presenters_array[0]) {
        temp_presenter_info = presenters_array[0]
      } else {
        temp_presenter_info = props.presentation_info.users[0]
      }
      temp_presenter_info = {...temp_presenter_info, nickname: assembleNickname(temp_presenter_info)}
      temp_presenter_info['nickname'] = assembleNickname(temp_presenter_info)
      
      if (temp_presenter_info.avatar_image_url) {
        let array = temp_presenter_info.avatar_image_url.split("/");

        temp_presenter_info = {...temp_presenter_info, adjusted_image_url: `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/circle_50x50/${array[5]}`}
      }

      if (temp_presenter_info.friendly_url) {
        temp_presenter_info = {
          ...temp_presenter_info,
          profile_link:
            workspace_base_url +
            local_routes.users +
            "/" +
            temp_presenter_info.friendly_url,
        };
      }

      set_presenter_info({...temp_presenter_info})
    }
  }, []);

  return (
    <div
      className={`present-block present-block-${userContext.theme} present-card present-card-${userContext.theme}`}
    >
      <div className="present-img">
        <Link to={presentation_link}>
          <div className="play-btn">
            {" "}
            <img src={playBtn} alt="img" className="img-fluid" />
          </div>
          <img
            src={adjusted_image_url || presentImg}
            alt="img"
            className="img-fluid thumbnail-img"
          />
        </Link>
      </div>
      <div
        className={`present-pop present-pop-${userContext.theme} present-card-pop`}
        style={{ marginTop: "-200px !important", float: "top" }}
      >
        <Row noGutters={true} className="justify-content-start">
          {presenter_info.adjusted_image_url && (
            <Col xs="2" className="justify-content-center">
              {presenter_info.profile_link ? (
                <Link
                  data-place="bottom"
                  data-tip={presenter_info.nickname}
                  to={presenter_info.profile_link}
                >
                  <img
                    style={{
                      display: "block",
                      marginLeft: "auto",
                      marginRight: "auto",
                      height: "36px",
                      width: "36px",
                    }}
                    src={presenter_info.adjusted_image_url || avatar}
                    alt="img"
                    className="img-fluid rounded-circle"
                  />
                </Link>
              ) : (
                <img
                  style={{
                    float: "none",
                    marginRight: "10px",
                    height: "36px",
                    width: "36px",
                  }}
                  src={presenter_info.adjusted_image_url || avatar}
                  alt="img"
                  className="img-fluid rounded-circle"
                />
              )}
            </Col>
          )}
          <Col xs={presenter_info.adjusted_image_url ? 10 : 12}>
            <Link
              data-place="bottom"
              data-tip={props.presentation_info.entity_name}
              to={presentation_link}
            >
              <h4
                className="line-clamp-2"
                style={{ marginTop: "-5px", lineHeight: "1.3" }}
              >
                {props.presentation_info.entity_name}
              </h4>
            </Link>
            <span
              style={{
                marginBottom: "5px",
                display: "block",
                lineHeight: "1.3",
                fontSize: "smaller",
              }}
            >
              {presenter_info.profile_link ? (
                <Link
                  data-tip={presenter_info.nickname}
                  to={presenter_info.profile_link}
                >
                  {presenter_info.nickname}
                  <br />
                </Link>
              ) : (
                <React.Fragment>
                  {presenter_info.nickname}
                  <br />
                </React.Fragment>
              )}
              <Link to={presentation_link}>
                {props.skip_relative_time ? (
                  <React.Fragment>{view_count_converted} views</React.Fragment>
                ) : (
                  <React.Fragment>
                    {view_count_converted} views &middot;{" "}
                    {getRelativeTime(props.presentation_info.created_time)}
                  </React.Fragment>
                )}
              </Link>
            </span>
          </Col>
        </Row>
        <ReactTooltip />
      </div>
    </div>
  );
};

export default withRouter(PresentationCard);


